export default "__VITE_ASSET__CATP66zy__"